import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=00145f5c"
import script from "./DeviceSettings.vue?vue&type=script&lang=js"
export * from "./DeviceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports